(ns motorsaif.web.subs
  (:require
   [motorsaif.shared.subs]
   [goog.net.Cookies :as gcookies]
   [goog.object :as obj]
   [re-frame.core :as rf :refer [reg-sub]]))

(def cookies (gcookies/getInstance))
;; TODO READ
;; https://github.com/day8/re-frame/pull/634

;; NOTE
;; Functions are used here so they can be used in events as
;; well without causing "outside reactive context" errors


(reg-sub :route/last-data
  (fn [db _]
    (-> db :route/last-data)))

(reg-sub :route/last-route-name
  (fn [db _]
    (-> db :route/last-data :data :name)))

(comment
  (:name (:data @(rf/subscribe [:route/last-data])))
  @(rf/subscribe [:route/last-route-name]))

(reg-sub :route/data
  (fn [db _]
    (-> db :route/data)))

(comment
  (rf/subscribe [:route/page-id])
  (:path-params @(rf/subscribe [:route/data])))

(reg-sub :route/page-id
  :<- [:route/data]
  (fn [route _]
    (-> route :data :name)))

;; The coerced path parameters
;; Non coerced are under key `:path-params`
(reg-sub :route/parameters
  :<- [:route/data]
  (fn [route _]
    (-> route :parameters :path)))

(reg-sub :route/page
  :<- [:route/data]
  (fn [route _]
    (-> route :data :view)))

(reg-sub :vsm
  (fn [db _]
    (:vsm db)))

(reg-sub :breakpoint
  :<- [:vsm]
  (fn [vsm _]
    (first (:breakpoint vsm))))

(reg-sub :modal
  (fn [db _]
    (:modal db)))

(reg-sub :locale
  (fn [db _]
    (let [?cookie (.get cookies "locale")]
      (get db :locale (keyword (or ?cookie :en))))))

(reg-sub :current-font-size
  (fn [db _]
    (get db :current-font-size "medium")))

(reg-sub :current-theme
  (fn [db _]
    (get db :current-theme)))
